import { useEffect, useRef } from 'react';
import { toastContent } from 'config/toast';
import { MiscStatusType } from 'types/StatusTypes';
import { isBrowserTranslatorActive } from 'utils/getUserFacingError';
import { useNovaToast } from './useNovaToast';

const TRANSLATOR_WARNING_TOAST_ID = 'translator-active-warning';

export const useGoogleTranslateDetection = (): void => {
  const toast = useNovaToast();
  const hasShownWarning = useRef(false);

  useEffect(() => {
    const showWarningIfNeeded = (): void => {
      if (!isBrowserTranslatorActive() || hasShownWarning.current) {
        return;
      }

      hasShownWarning.current = true;
      toast.show({
        id: TRANSLATOR_WARNING_TOAST_ID,
        ...toastContent.misc[MiscStatusType.TRANSLATOR_ACTIVE],
      });
    };

    showWarningIfNeeded();

    const observer = new MutationObserver(showWarningIfNeeded);
    observer.observe(document.documentElement, {
      attributes: true,
      attributeFilter: ['class'],
    });

    return () => observer.disconnect();
  }, [toast]);
};
